import React from "react";
import UnsupportedFallback from "./renderers/UnsupportedFallback";

type PreviewErrorBoundaryProps = {
  resetKey: string;
  fileName: string;
  onDownload?: () => void;
  children: React.ReactNode;
};

type PreviewErrorBoundaryState = {
  failed: boolean;
  resetKey: string;
};

class PreviewErrorBoundary extends React.Component<
  PreviewErrorBoundaryProps,
  PreviewErrorBoundaryState
> {
  constructor(props: PreviewErrorBoundaryProps) {
    super(props);
    this.state = { failed: false, resetKey: props.resetKey };
  }

  static getDerivedStateFromError(): Partial<PreviewErrorBoundaryState> {
    return { failed: true };
  }

  static getDerivedStateFromProps(
    props: PreviewErrorBoundaryProps,
    state: PreviewErrorBoundaryState
  ): Partial<PreviewErrorBoundaryState> | null {
    if (props.resetKey !== state.resetKey) {
      return { failed: false, resetKey: props.resetKey };
    }
    return null;
  }

  render() {
    if (this.state.failed) {
      return (
        <UnsupportedFallback fileName={this.props.fileName} onDownload={this.props.onDownload} />
      );
    }
    return this.props.children;
  }
}

export default PreviewErrorBoundary;
